import React from 'react';
import RichText from '..';
import './styles.scss';

type SimpleBlockProps = {
  data: {
    htmlId: string | null;
    content: any;
  };
}


function SimpleBlock({ data }: SimpleBlockProps) {
  return (
      <div className="simple-block">
        <div id={data.htmlId ?? undefined} class="anchor"></div>
        <RichText value={data.content} />
      </div>
  );
}

export default SimpleBlock;


